import { BI_API_BASE } from "../config";
import { clearCachedEmployeeEmail, markSignedOut } from "./identity";
import { clearReturnTo } from "./return-to";

interface SignOutLocation {
  readonly origin: string;
  assign(url: string): void;
  reload(): void;
}

/**
 * Return the cookie-clearing logout URL when the API is on this SPA's origin.
 * In cloud `BI_API_BASE` is empty (same-origin through the LB), so the backend
 * redirect clears the `bi_authority` cookie. Local dev is cross-origin
 * (:5377 -> :8200) with stub auth and no redirect to follow: return null so the
 * caller clears local identity and reloads.
 */
export function resolveBiLogoutUrl(apiBase: string, currentOrigin: string): string | null {
  const origin = new URL(currentOrigin).origin;
  const logoutUrl = new URL("/api/bi/auth/google/logout", apiBase.trim() || origin);
  return logoutUrl.origin === origin ? logoutUrl.href : null;
}

/** End both forms of BI identity: the local stub and the cloud OAuth cookie. */
export function signOutBi(
  location: SignOutLocation = window.location,
  apiBase: string = BI_API_BASE,
): void {
  markSignedOut();
  clearCachedEmployeeEmail();
  // Logout also lands on "/", which is exactly where a remembered deep link is
  // restored — drop it, so signing out cannot bounce the reader back into the
  // dashboard they were last signed in for (lib/return-to.ts).
  clearReturnTo();

  const logoutUrl = resolveBiLogoutUrl(apiBase, location.origin);
  if (logoutUrl) {
    location.assign(logoutUrl);
    return;
  }

  location.reload();
}
